export default __webpack_public_path__ + "static/media/Group 6489.5b418a7e.svg";